import GerepAPI from '../../api/gerep/GerepAPI'

export default class InterstitielService {

	static getInterstitiels(token) {
		return GerepAPI.get('/interstitiels', null, token)
	}
}
